module.exports = __webpack_public_path__ + "media/images/niq-copy-096dfef4ef20244084bffc82a60c7c39.png";